import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { checkAuthStatus } from '../api/client'

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const [status, setStatus] = useState<'loading' | 'ok' | 'unauth'>('loading')

  useEffect(() => {
    checkAuthStatus()
      .then(s => setStatus(s.authenticated ? 'ok' : 'unauth'))
      .catch(() => setStatus('unauth'))
  }, [])

  if (status === 'loading') {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="loading-spinner" />
      </div>
    )
  }
  if (status === 'unauth') return <Navigate to="/login" replace />
  return <>{children}</>
}
